<form [formGroup]="form" (ngSubmit)="onSave()" class="formgrid grid">

  <div class="col-5">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Name</h3>
    <input pInputText formControlName="name" type="text" class="inputfield w-full"
      [ngClass]="{ 'ng-invalid ng-dirty': form.get('name')?.invalid && form.get('name')?.touched }"
      placeholder="Direct cremation" />
  </div>

  <div class="col-4">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Id</h3>
    <input pInputText formControlName="id" type="text" class="inputfield w-full font-mono"
      [ngClass]="{ 'ng-invalid ng-dirty': form.get('id')?.invalid && form.get('id')?.touched }"
      placeholder="direct-cremation" />
    <small class="block text-500 mt-1">
      {{ isNew ? 'Lowercase letters, numbers and dashes. Referenced by page blocks and {price:…} — it can never change.' : "The id can't change — page blocks and prices reference it." }}
    </small>
  </div>

  <div class="col-3">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Category</h3>
    <p-dropdown formControlName="category" [options]="categoryOptions" styleClass="w-full" appendTo="body"></p-dropdown>
  </div>

  <div class="col-12">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Short description</h3>
    <textarea pInputTextarea formControlName="shortDescription" rows="2" class="inputfield w-full"
      placeholder="An unattended cremation with no service…"></textarea>
    <small class="block text-500 mt-1">The Google-listing description and the card copy — one or two sentences.</small>
  </div>

  <div class="col-12">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Full description</h3>
    <textarea pInputTextarea formControlName="fullDescription" rows="3" class="inputfield w-full"
      placeholder="A direct cremation is a no-service, no-attendance cremation…"></textarea>
    <small class="block text-500 mt-1">The lead paragraph under the page's main heading.</small>
  </div>

  <div class="col-4">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Starting price ($)</h3>
    <input pInputText formControlName="startingPrice" type="number" min="1" class="inputfield w-full" placeholder="no price shown" />
    <small class="block text-500 mt-1">
      Shows as "from $…" in the page title, the hero button, and the home cards. Empty hides the
      button and card price — but if the page's title mentions the price, the publish will ask you
      to update the page too.
    </small>
  </div>

  <div class="col-2">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Order</h3>
    <input pInputText formControlName="order" type="number" class="inputfield w-full" />
  </div>

  <div class="col-3 flex align-items-center mt-4">
    <p-inputSwitch class="flex-initial" formControlName="featured"></p-inputSwitch>
    <span class="ml-2 text-700">Featured
      <small class="block text-500">On the home page cards.</small>
    </span>
  </div>

  <div class="col-3 flex align-items-center mt-4">
    <p-inputSwitch class="flex-initial" formControlName="published"></p-inputSwitch>
    <span class="ml-2 text-700">Published
      <small class="block text-500">Off = removed from the site's data on next publish.</small>
    </span>
  </div>

  <div class="col-12">
    <div class="flex align-items-center justify-content-between border-bottom-1 border-200">
      <h3 class="text-500 my-2">What's included</h3>
      <button pButton pRipple type="button" label="Add item" icon="pi pi-plus"
        class="p-button-text p-button-sm" (click)="addInclusion()"></button>
    </div>
    <div *ngFor="let it of inclusions; let i = index; let last = last" class="flex gap-2 align-items-center mb-2">
      <input pInputText type="text" class="inputfield flex-1" [(ngModel)]="it.text"
        [ngModelOptions]="{ standalone: true }" placeholder="Transfer of the deceased to the crematorium" />
      <button pButton pRipple type="button" icon="pi pi-chevron-up" class="p-button-rounded p-button-text p-button-sm"
        [disabled]="i === 0" (click)="moveInclusion(i, -1)"></button>
      <button pButton pRipple type="button" icon="pi pi-chevron-down" class="p-button-rounded p-button-text p-button-sm"
        [disabled]="last" (click)="moveInclusion(i, 1)"></button>
      <button pButton pRipple type="button" icon="pi pi-times" class="p-button-text p-button-danger"
        (click)="removeInclusion(i)"></button>
    </div>
    <p *ngIf="!inclusions.length" class="text-500 text-sm">None — the page's "What's included" section won't show.</p>
  </div>

  <div class="col-12">
    <div class="flex align-items-center justify-content-between border-bottom-1 border-200">
      <h3 class="text-500 my-2">Service FAQs</h3>
      <button pButton pRipple type="button" label="Add FAQ" icon="pi pi-plus"
        class="p-button-text p-button-sm" (click)="addFaq()"></button>
    </div>
    <div *ngFor="let f of faqs; let i = index; let last = last" class="border-1 border-200 border-round p-2 mb-2">
      <div class="flex gap-2 align-items-start">
        <div class="flex-1">
          <input pInputText type="text" class="inputfield w-full mb-2" [(ngModel)]="f.question"
            [ngModelOptions]="{ standalone: true }" placeholder="Can the family attend a direct cremation?" />
          <textarea pInputTextarea rows="2" class="inputfield w-full" [(ngModel)]="f.answer"
            [ngModelOptions]="{ standalone: true }" placeholder="The answer — 40–80 words reads best in search results."></textarea>
        </div>
        <div class="flex flex-column">
          <button pButton pRipple type="button" icon="pi pi-chevron-up" class="p-button-rounded p-button-text p-button-sm"
            [disabled]="i === 0" (click)="moveFaq(i, -1)"></button>
          <button pButton pRipple type="button" icon="pi pi-chevron-down" class="p-button-rounded p-button-text p-button-sm"
            [disabled]="last" (click)="moveFaq(i, 1)"></button>
          <button pButton pRipple type="button" icon="pi pi-times" class="p-button-text p-button-danger"
            (click)="removeFaq(i)"></button>
        </div>
      </div>
    </div>
    <p *ngIf="!faqs.length" class="text-500 text-sm">None — the page's FAQ section won't show.</p>
  </div>

  <div class="col-12 flex justify-content-end gap-2 mt-3">
    <button pButton pRipple type="button" label="Cancel" class="p-button-text" [disabled]="saving" (click)="onCancel()"></button>
    <button pButton pRipple type="submit" label="Save" icon="pi pi-check" [loading]="saving"></button>
  </div>

</form>
